// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.W3do51u5XqIM8bGgTVA8 {
	display: flex;
	flex-direction: column;
}

.noF9AxbR5n2uiu0tYvje {
	display: flex;
	flex-direction: column;
}

.noF9AxbR5n2uiu0tYvje > * {
	border-top: 0.5px solid rgba(0, 0, 0, 0.2);
}

.yntx5O23pdo_aADDIpVQ {
	color: var(--black);
	font-size: 16px;
	letter-spacing: -0.08em;
	line-height: 24px;
	margin-bottom: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/VESISPage/TotalStakingOverview/TotalStakingOverview.pcss"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,sBAAsB;AACvB;;AAEA;CACC,aAAa;CACb,sBAAsB;AACvB;;AAEA;CACC,0CAA0C;AAC3C;;AAEA;CACC,mBAAmB;CACnB,eAAe;CACf,uBAAuB;CACvB,iBAAiB;CACjB,kBAAkB;AACnB","sourcesContent":[".container {\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n.content {\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n.content > * {\n\tborder-top: 0.5px solid rgba(0, 0, 0, 0.2);\n}\n\n.title {\n\tcolor: var(--black);\n\tfont-size: 16px;\n\tletter-spacing: -0.08em;\n\tline-height: 24px;\n\tmargin-bottom: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `W3do51u5XqIM8bGgTVA8`,
	"content": `noF9AxbR5n2uiu0tYvje`,
	"title": `yntx5O23pdo_aADDIpVQ`
};
export default ___CSS_LOADER_EXPORT___;
